/* assets/custom-categories.js */

(function () {
  // Initialize navigation switching, accordions toggling, and search events
  function initCategoriesNavigation() {
    const containers = document.querySelectorAll('.custom-categories-container');
    containers.forEach(container => {
      // 1. Department Tabs Switch Event
      const deptTabs = container.querySelectorAll('.custom-categories__dept-tab');
      deptTabs.forEach(tab => {
        if (tab.dataset.bound) return;
        tab.dataset.bound = 'true';

        tab.addEventListener('click', function () {
          const deptIndex = this.dataset.deptIndex;

          // Reset tab classes
          deptTabs.forEach(t => t.classList.remove('is-active'));
          this.classList.add('is-active');

          // Hide all panels, show target one
          const panels = container.querySelectorAll('.custom-categories__dept-panel');
          panels.forEach(panel => {
            panel.classList.remove('is-active');
            if (panel.id === `DeptPanel-${deptIndex}` || panel.id === `DeptPanel-Header-${deptIndex}`) {
              panel.classList.add('is-active');
              
              // Auto-trigger click on the first sidebar item of the active panel to prevent blank states
              const firstSidebarItem = panel.querySelector('.custom-categories__sidebar-item');
              if (firstSidebarItem) {
                firstSidebarItem.click();
              }
            }
          });
        });
      });

      // 2. Sidebar L1 Categories Switch Event
      const sidebarItems = container.querySelectorAll('.custom-categories__sidebar-item');
      
      function switchSidebarSheet(item) {
        const parentIndex = item.dataset.parentIndex;
        const panel = item.closest('.custom-categories__dept-panel');
        if (!panel) return;

        // Reset sidebar active states within the active panel
        const panelSidebarItems = panel.querySelectorAll('.custom-categories__sidebar-item');
        panelSidebarItems.forEach(si => si.classList.remove('is-active'));
        item.classList.add('is-active');

        // Reset right content sheets within the active panel
        const sheets = panel.querySelectorAll('.custom-categories__parent-sheet');
        sheets.forEach(sheet => {
          sheet.classList.remove('is-active');
          if (sheet.dataset.sheetIndex === parentIndex) {
            sheet.classList.add('is-active');
          }
        });
      }

      sidebarItems.forEach(item => {
        if (item.dataset.bound) return;
        item.dataset.bound = 'true';

        // Click handler for mobile/tablet and click fallback
        item.addEventListener('click', function () {
          switchSidebarSheet(this);
        });

        // Hover handler for desktop viewports
        item.addEventListener('mouseenter', function () {
          if (window.innerWidth >= 990) {
            switchSidebarSheet(this);
          }
        });
      });

      // 3. Level 2 Accordion Header Toggles (only applicable outside header mega-menu context)
      const accordionHeaders = container.querySelectorAll('.custom-categories__accordion-header');
      accordionHeaders.forEach(header => {
        if (header.dataset.bound) return;
        header.dataset.bound = 'true';

        header.addEventListener('click', function () {
          // Prevent collapsing on desktop header mega menu where accordions act as static layouts
          if (window.innerWidth >= 990 && this.closest('.custom-header__mega-menu')) return;
          const group = this.closest('.custom-categories__accordion-group');
          group.classList.toggle('is-expanded');
        });
      });

      // 4. Client-side Categories search filtering
      const searchInput = container.querySelector('#CategoriesSearchInput');
      if (searchInput && !searchInput.dataset.bound) {
        searchInput.dataset.bound = 'true';
        searchInput.addEventListener('input', function () {
          const query = this.value.trim().toLowerCase();
          filterCategoriesByQuery(container, query);
        });
      }
    });
  }

  // Live filter grid items matching queries and automatically expand accordions showing results
  function filterCategoriesByQuery(container, query) {
    const gridItems = container.querySelectorAll('.custom-categories__grid-item:not(.custom-categories__grid-item--shop-all)');
    const accordionGroups = container.querySelectorAll('.custom-categories__accordion-group');
    const shopAllItems = container.querySelectorAll('.custom-categories__grid-item--shop-all');
    const gridContents = container.querySelectorAll('.custom-categories__grid-content');

    if (query === '') {
      // Restore all original display states
      gridItems.forEach(item => {
        item.style.display = '';
      });
      shopAllItems.forEach(item => {
        item.style.display = '';
      });
      gridContents.forEach(content => {
        content.style.display = '';
      });
      accordionGroups.forEach((group, index) => {
        group.style.display = '';
        // Collapse all except the first accordion item per page to match standard load state
        if (index === 0) {
          group.classList.add('is-expanded');
        } else {
          group.classList.remove('is-expanded');
        }
      });
      return;
    }

    // Hide Shop All shortcuts during active searching to focus results
    shopAllItems.forEach(item => {
      item.style.display = 'none';
    });

    // Process accordion group hierarchies
    accordionGroups.forEach(group => {
      let matchedCountInGroup = 0;
      const groupCards = group.querySelectorAll('.custom-categories__grid-item:not(.custom-categories__grid-item--shop-all)');

      groupCards.forEach(card => {
        const label = card.dataset.searchLabel || '';
        if (label.includes(query)) {
          card.style.display = '';
          matchedCountInGroup++;
        } else {
          card.style.display = 'none';
        }
      });

      if (matchedCountInGroup > 0) {
        group.style.display = '';
        group.classList.add('is-expanded'); // auto-expand accordion showing matched products
      } else {
        group.style.display = 'none';
        group.classList.remove('is-expanded');
      }
    });

    // Process childless grid content containers
    gridContents.forEach(content => {
      let matchedCountInGrid = 0;
      const gridCards = content.querySelectorAll('.custom-categories__grid-item:not(.custom-categories__grid-item--shop-all)');

      gridCards.forEach(card => {
        const label = card.dataset.searchLabel || '';
        if (label.includes(query)) {
          card.style.display = '';
          matchedCountInGrid++;
        } else {
          card.style.display = 'none';
        }
      });

      if (matchedCountInGrid > 0) {
        content.style.display = '';
      } else {
        content.style.display = 'none';
      }
    });
  }

  function initDesktopSidebarNavigation() {
    const sidebar = document.querySelector('.custom-header__sidebar-desktop');
    if (!sidebar) return;

    const toggles = sidebar.querySelectorAll('.custom-header__sidebar-toggle');
    toggles.forEach(toggle => {
      if (toggle.dataset.bound) return;
      toggle.dataset.bound = 'true';

      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        const submenu = this.nextElementSibling;
        if (!submenu) return;
        const isExpanded = this.getAttribute('aria-expanded') === 'true';

        // Toggle current accordion
        if (isExpanded) {
          this.setAttribute('aria-expanded', 'false');
          submenu.style.display = 'none';
        } else {
          // Close other submenus
          toggles.forEach(otherToggle => {
            if (otherToggle !== this) {
              otherToggle.setAttribute('aria-expanded', 'false');
              if (otherToggle.nextElementSibling) {
                otherToggle.nextElementSibling.style.display = 'none';
              }
            }
          });

          this.setAttribute('aria-expanded', 'true');
          submenu.style.display = 'block';
        }
      });
    });

    // Expand active submenus on page load/ready
    toggles.forEach(toggle => {
      const submenu = toggle.nextElementSibling;
      if (submenu && (submenu.querySelector('.is-active') || window.location.pathname === toggle.getAttribute('data-url'))) {
        toggle.setAttribute('aria-expanded', 'true');
        submenu.style.display = 'block';
      }
    });
  }

  function initDesktopSidebarFlyouts() {
    const sidebar = document.querySelector('.custom-header__sidebar-desktop');
    if (!sidebar) return;

    const sublinks = sidebar.querySelectorAll('.custom-header__sidebar-sublink');
    const flyouts = document.querySelectorAll('.custom-header__sidebar-flyout');
    const backdrop = document.getElementById('sidebar-backdrop');

    function showFlyout(deptIndex, linkIndex) {
      const targetId = `Flyout-${deptIndex}-${linkIndex}`;
      let targetFlyout = null;

      flyouts.forEach(flyout => {
        if (flyout.id === targetId) {
          flyout.classList.add('is-active');
          targetFlyout = flyout;
        } else {
          flyout.classList.remove('is-active');
        }
      });

      if (targetFlyout) {
        // Show backdrop
        if (backdrop) backdrop.classList.add('is-active');

        // Make sure only the parent-sheet matching linkIndex is active inside the flyout
        const sheets = targetFlyout.querySelectorAll('.custom-categories__parent-sheet');
        sheets.forEach(sheet => {
          if (sheet.dataset.sheetIndex === String(linkIndex)) {
            sheet.classList.add('is-active');
          } else {
            sheet.classList.remove('is-active');
          }
        });
      } else {
        if (backdrop) backdrop.classList.remove('is-active');
      }
    }

    function hideAllFlyouts() {
      flyouts.forEach(flyout => flyout.classList.remove('is-active'));
      if (backdrop) backdrop.classList.remove('is-active');
      sublinks.forEach(sublink => sublink.classList.remove('is-active-sidebar-link'));
    }

    sublinks.forEach(link => {
      if (link.dataset.bound) return;
      link.dataset.bound = 'true';

      // Toggle flyout on click
      link.addEventListener('click', function (e) {
        const deptIndex = this.dataset.deptIndex;
        const linkIndex = this.dataset.linkIndex;
        const targetId = `Flyout-${deptIndex}-${linkIndex}`;
        const hasFlyout = document.getElementById(targetId);
        
        if (hasFlyout) {
          e.preventDefault();
          const isActive = hasFlyout.classList.contains('is-active');
          
          if (isActive) {
            // Already open: close it
            hideAllFlyouts();
          } else {
            // Otherwise open it
            showFlyout(deptIndex, linkIndex);
            
            // Highlight the active sidebar sublink
            sublinks.forEach(sublink => sublink.classList.remove('is-active-sidebar-link'));
            this.classList.add('is-active-sidebar-link');
          }
        }
      });
    });

    // Close on clicking backdrop
    if (backdrop && !backdrop.dataset.bound) {
      backdrop.dataset.bound = 'true';
      backdrop.addEventListener('click', function () {
        hideAllFlyouts();
      });
    }

    // Bind accordion togglers inside flyouts
    const accordionHeaders = document.querySelectorAll('.custom-header__sidebar-flyout .custom-categories__accordion-header');
    accordionHeaders.forEach(header => {
      if (header.dataset.bound) return;
      header.dataset.bound = 'true';
      header.addEventListener('click', function () {
        const group = this.closest('.custom-categories__accordion-group');
        if (group) {
          group.classList.toggle('is-expanded');
        }
      });
    });
  }

  function initMobileCategoriesDrawer() {
    const bottomNavCategories = document.getElementById('mobile-bottom-nav-categories');
    const hamburgerTrigger = document.getElementById('mobile-hamburger-trigger');
    const drawer = document.getElementById('global-categories-drawer');
    if (!drawer) return;

    const backdrop = document.getElementById('categories-drawer-backdrop');
    const closeBtn = document.getElementById('categories-drawer-close');
    const body = document.body;

    function openDrawer(e) {
      if (window.innerWidth >= 990) return; // Only active on mobile
      
      e.preventDefault();
      drawer.classList.add('is-active');
      body.classList.add('custom-search-lock');
      
      // Re-initialize categories navigation inside the drawer
      initCategoriesNavigation();
    }

    function closeDrawer() {
      drawer.classList.remove('is-active');
      body.classList.remove('custom-search-lock');
    }

    // Toggle on bottom tab click
    if (bottomNavCategories && !bottomNavCategories.dataset.bound) {
      bottomNavCategories.dataset.bound = 'true';
      bottomNavCategories.addEventListener('click', openDrawer);
    }

    // Toggle on hamburger click
    if (hamburgerTrigger && !hamburgerTrigger.dataset.bound) {
      hamburgerTrigger.dataset.bound = 'true';
      hamburgerTrigger.addEventListener('click', openDrawer);
    }

    // Close handlers
    if (closeBtn && !closeBtn.dataset.bound) {
      closeBtn.dataset.bound = 'true';
      closeBtn.addEventListener('click', closeDrawer);
    }

    if (backdrop && !backdrop.dataset.bound) {
      backdrop.dataset.bound = 'true';
      backdrop.addEventListener('click', closeDrawer);
    }
  }

  // Load handlers
  function initializeAll() {
    initCategoriesNavigation();
    initDesktopSidebarNavigation();
    initDesktopSidebarFlyouts();
    initMobileCategoriesDrawer();
  }

  if (document.readyState !== 'loading') {
    initializeAll();
  } else {
    document.addEventListener('DOMContentLoaded', initializeAll);
  }

  // Shopify Customizer Section reloading triggers
  document.addEventListener('shopify:section:load', (event) => {
    if (event.detail.sectionId && event.target.querySelector('.custom-categories-container')) {
      initCategoriesNavigation();
    }
    if (event.detail.sectionId && event.target.querySelector('.custom-header__sidebar-desktop')) {
      initDesktopSidebarNavigation();
      initDesktopSidebarFlyouts();
    }
    initMobileCategoriesDrawer();
  });
})();
